import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { AccomplishmentDetails } from '../domain/accomplishment-details.model';

@Component({
  selector: 'rma-profile-accomplishment-item',
  templateUrl: './accomplishment-item.component.html',
  styleUrls: ['./accomplishment-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TranslocoModule],
})
export class AccomplishmentItemComponent {
  @Input() accomplishment!: AccomplishmentDetails;
}
